/** axios封装的接口请求方法 */
import axios from "axios";
import VueCookies from "vue-cookies";
import { ElMessage } from "element-plus";
import { remindErrorMessage } from "../utils/utils";
import { goLogin } from "../utils/login";
import router from "@/router";
import store from "@/store";

let qs = require("qs");

axios.defaults.withCredentials = false;

/**开发环境 */
let baseUrl = ``;
// let baseAuthUrl = `http://101.132.106.2:8065/auth`; //uums

/**线上环境 production */
// let baseUrl = ``;
let baseAuthUrl = `https://i.ringdata.com/uums`; //uums

/**
 * post 请求
 */
const httpPost = async function (url = "", data = {}, contentType, rType) {
  // 刷新Token
  if (!VueCookies.isKey("tokenWeb") && VueCookies.isKey("tokenWebRefresh")) {
    await httpPostRefreshToken(
      "/oauth/token",
      VueCookies.get("tokenWebRefresh")
    );
  }
  // 判断使用的url
  let tempUrl = baseUrl;
  const instance = axios.create({
    baseURL: tempUrl,
    withCredentials: false,
    headers: {
      Accept: "application/json;charset=UTF-8",
      "Content-type": contentType ? contentType : "application/json",
      Authorization: VueCookies.get("tokenWeb")
        ? "Bearer " + VueCookies.get("tokenWeb")
        : "",
    },
    responseType: rType,
  });
  return instance
    .post(url, data)
    .then((result) => {
      var res = result.data;
      if (res && res.code === 0) {
        return Promise.resolve(res);
      } else {
        if (res.code === 15000) {
          ElMessage.warning("网络请求异常，请稍后再试或联系客服！");
          return res;
        } else if (res.code === 10000 || res.code === 20000) {
          ElMessage({
            message: res.message,
            type: "warning",
          });
          return res;
        } else if (res.code === 10001) {
          store.commit("setLoginStatus", {
            status: false,
          });
          if (res.data) {
            remindErrorMessage("登录信息已失效,请重新登录");
            store.commit("setLoginStatus", {
              status: false,
            });
            let { userId } = VueCookies.get("userInfo");
            VueCookies.remove("tokenWeb");
            VueCookies.remove("userInfo");
            VueCookies.remove("tokenWebRefresh");
            VueCookies.remove("tokenWeb", "/", "smartsowo.com");
            VueCookies.remove("userInfo", "/", "smartsowo.com");
            VueCookies.remove("tokenWebRefresh", "/", "smartsowo.com");
          } else {
            remindErrorMessage("登录信息已失效,请重新登录");
          }
          setTimeout(() => {
            window.location.reload();
          }, 500);
          return res;
        } else if (res.code === 10010) {
          // 无权限
          window.location.href = window.location.origin + "/no-auth";
        }
        return Promise.resolve(res);
      }
    })
    .catch((error) => {
      let res = error.response;
      if (res.status === 400 || res.status === 401) {
        store.commit("setLoginStatus", {
          status: false,
        });
        if (res.data) {
          remindErrorMessage("登录信息已失效,请重新登录");
          store.commit("setLoginStatus", {
            status: false,
          });
          let { userId } = VueCookies.get("userInfo");
          VueCookies.remove("tokenWeb");
          VueCookies.remove("userInfo");
          VueCookies.remove("tokenWebRefresh");
          VueCookies.remove("tokenWeb", "/", "smartsowo.com");
          VueCookies.remove("userInfo", "/", "smartsowo.com");
          VueCookies.remove("tokenWebRefresh", "/", "smartsowo.com");
        } else {
          remindErrorMessage("登录信息已失效,请重新登录");
        }
        setTimeout(() => {
          window.location.reload();
        }, 500);
        return res;
      }
      res = {
        code: -1,
        message: "网络请求异常，请稍后再试或联系客服！",
      };
      console.log("网络请求错误");
      return res;
    });
};

/**
 * 刷新token请求
 */
const httpPostRefreshToken = async function (url = "", refreshToken) {
  var ip = window.localStorage.getItem("ip");
  var city = window.localStorage.getItem("city");
  var client = "DOCUMENT";
  var data = `grant_type=refresh_token&refresh_token=${refreshToken}&clientType=${client}&ip=${ip}&city=${city}`;
  const instance = axios.create({
    baseURL: baseAuthUrl,
    withCredentials: false,
    headers: {
      Authorization: "Basic bW9uZXR3YXJlOm1vbmV0d2FyZTIwMTkuQHNoLmNvbQ==",
      "content-type": "application/x-www-form-urlencoded;charset=utf-8",
    },
  });
  return instance
    .post(url, data)
    .then((result) => {
      var res = result.data;
      if (result && result.status === 200) {
        if (res != null && res.access_token != null && res.access_token != "") {
          //production
          VueCookies.set(
            "tokenWeb",
            res.access_token,
            24 * 60 * 60,
            "/",
            "smartsowo.com",
            false
          );
          VueCookies.set(
            "tokenWebRefresh",
            res.refresh_token,
            47 * 60 * 60,
            "/",
            "smartsowo.com",
            false
          );
          VueCookies.set(
            "userInfo",
            JSON.stringify(res.userInfo),
            24 * 60 * 60,
            "/",
            "smartsowo.com",
            false
          );
          res = {
            code: 0,
            message: "登录成功",
          };
          return Promise.resolve(res);
        } else {
          res = {
            code: -1,
            message: "认证失败，请稍后再试或联系客服！",
          };
          return res;
        }
      }
    })
    .catch((error) => {
      let res = error.response;
      if (res.status === 400 || res.status === 401 || res.status === 500) {
        res = {
          code: res.data.code,
          message: res.data.message,
        };
        return res;
      }
      res = {
        code: -1,
        message: "网络请求异常，请稍后再试或联系客服！",
      };
      console.log("网络请求错误");
      return res;
    });
};

/**
 * UUMS post 请求
 */
const httpAuthPost = async function (url = "", data = {}) {
  // 刷新Token
  if (!VueCookies.isKey("tokenWeb") && VueCookies.isKey("tokenWebRefresh")) {
    await httpPostRefreshToken(
      "/oauth/token",
      VueCookies.get("tokenWebRefresh")
    );
  }
  let tempUrl = baseAuthUrl;
  const instance = axios.create({
    baseURL: tempUrl,
    withCredentials: false,
    headers: {
      Accept: "application/json;charset=UTF-8",
      "content-type": "application/json",
      Authorization: VueCookies.get("tokenWeb")
        ? "Bearer " + VueCookies.get("tokenWeb")
        : "",
    },
  });
  return instance
    .post(url, JSON.stringify(data))
    .then((result) => {
      var res = result.data;
      if (res && res.code === 0) {
        return Promise.resolve(res);
      } else {
        if (res.code === 15000) {
          remindErrorMessage("网络请求异常，请稍后再试或联系客服！");
          return res;
        } else if (res.code === 10000) {
          ElMessage({
            message: res.message,
            type: "warning",
          });
          return res;
        }
        return Promise.resolve(res);
      }
    })
    .catch((error) => {
      let res = error.response;
      if (res.status === 400 || res.status === 401 || res.status === 500) {
        store.commit("setLoginStatus", {
          status: false,
        });
        if (res.data) {
          ElMessage({
            message: res.data.message,
            type: "warning",
          });
          store.commit("setLoginStatus", {
            status: false,
          });
          let { userId } = VueCookies.get("userInfo");
          VueCookies.remove("tokenWeb");
          VueCookies.remove("userInfo");
          VueCookies.remove("tokenWebRefresh");
          VueCookies.remove("tokenWeb", "/", "smartsowo.com");
          VueCookies.remove("userInfo", "/", "smartsowo.com");
          VueCookies.remove("tokenWebRefresh", "/", "smartsowo.com");
        } else {
          remindErrorMessage("登录信息已失效,请重新登录");
        }
        setTimeout(() => {
          window.location.reload();
        }, 500);
        return res;
      }
      res = {
        code: -1,
        message: "网络请求异常，请稍后再试或联系客服！",
      };
      console.log("网络请求错误");
      return res;
    });
};

/**
 * 认证请求
 */
const httpPostToken = async function (url = "", data) {
  const instance = axios.create({
    baseURL: baseAuthUrl,
    withCredentials: false,
    headers: {
      Authorization: "Basic bW9uZXR3YXJlOm1vbmV0d2FyZTIwMTkuQHNoLmNvbQ==",
      "content-type": "application/x-www-form-urlencoded;charset=utf-8",
    },
  });
  return instance
    .post(url, data)
    .then((result) => {
      var res = result.data;
      if (result && result.status === 200) {
        if (res != null && res.access_token != null && res.access_token != "") {
          // key（字符串）：要设置的cookie的名称。
          // value（字符串）：要设置的cookie的值。
          // expires（可选）：cookie的过期时间，可以是一个数字（表示从当前时间开始的秒数）或一个日期对象（表示过期日期）。如果不提供，cookie将在会话结束后过期。
          // path（可选）：cookie的路径。默认是根路径 /。
          // domain（可选）：cookie的域。默认是当前域名。
          // secure（可选）：布尔值，表示cookie是否只能通过安全连接（HTTPS）传输。默认是 false。
          // sameSite（可选）：cookie的SameSite属性，可以是 "Strict"、"Lax" 或 "None"。默认是 "Lax"。
          //production
          VueCookies.set(
            "tokenWeb",
            res.access_token,
            24 * 60 * 60,
            "/",
            "smartsowo.com",
            false
          );
          VueCookies.set(
            "tokenWebRefresh",
            res.refresh_token,
            47 * 60 * 60,
            "/",
            "smartsowo.com",
            false
          );
          VueCookies.set(
            "userInfo",
            JSON.stringify(res.userInfo),
            24 * 60 * 60,
            "/",
            "smartsowo.com",
            false
          );
          res = {
            code: 0,
            message: "登录成功",
          };
          return Promise.resolve(res);
        } else {
          res = {
            code: -1,
            message: "认证失败，请稍后再试或联系客服！",
          };
          return res;
        }
      }
    })
    .catch((error) => {
      let res = error.response;
      if (res.status === 400 || res.status === 401 || res.status === 500) {
        res = {
          code: res.data.code,
          message: res.data.message,
        };
        ElMessage({
          message: res.message,
          type: "warning",
        });
      } else {
        res = {
          code: -1,
          message: "网络请求异常，请稍后再试或联系客服！",
        };
        remindErrorMessage("网络请求异常，请稍后再试或联系客服！");
      }

      return res;
    });
};

/**
 * post 请求 uums
 */
const httpPostIsAnonymous = async function (url = "", data = {}) {
  const instance = axios.create({
    baseURL: baseAuthUrl,
    withCredentials: false,
    headers: {
      Accept: "application/json;charset=UTF-8",
      "content-type": "application/json",
    },
  });
  return instance
    .post(url, JSON.stringify(data))
    .then((result) => {
      var res = result.data;
      if (res && res.code === 0) {
        return Promise.resolve(res);
      } else {
        if (res.code === 15000) {
          remindErrorMessage("网络请求异常，请稍后再试或联系客服！");
          return res;
        }
        return Promise.resolve(res);
      }
    })
    .catch(() => {
      let res = {
        code: -1,
        message: "网络请求异常，请稍后再试或联系客服！",
      };
      console.log("网络请求错误");
      return res;
    });
};

export {
  baseUrl,
  baseAuthUrl,
  httpPost,
  httpAuthPost,
  httpPostToken,
  httpPostIsAnonymous,
  httpPostRefreshToken,
};
